<template>
  <div>
    <el-card class="box-card">
      <el-form :model="addForm" ref="addFormRef" label-width="74px">
        <el-form-item label="处理结果" class="addAdminForm">
          <el-input type="textarea" v-model="addForm.beizhu" placeholder="请输入内容" rows="10"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="backDeviceExceptionReminder">返回</el-button>
        </el-form-item>
      </el-form>

      <div class="title mt20">设备处理异常记录</div>
      <el-table :data="dataList" border stripe class="mt15">
        <el-table-column prop="Beizhu" label="备注"></el-table-column>
        <el-table-column prop="Adminname" label="操作人员"></el-table-column>
        <el-table-column prop="Createtime" label="操作时间"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      addForm: {
        beizhu: ''
      },
      dataList: [],
      parentdata: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.apiGetDeviceExceptionReminderProcess()
    },
    backDeviceExceptionReminder () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiAddDeviceExceptionReminderProcess()
    },
    apiGetDeviceExceptionReminderProcess: function (type, parentid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetDeviceExceptionReminderProcess, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddDeviceExceptionReminderProcess: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        beizhu: this.addForm.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddDeviceExceptionReminderProcess, Qs.stringify(data))
        .then(function (response) {
          that.apiGetDeviceExceptionReminderProcess()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
